// sticky header
function headerscroll() {
  var headerheight = $("header").height();
  var scroll = $(window).scrollTop();
  if (scroll >= headerheight) {
      $("header").addClass("sticky");
  } else {
      $("header").removeClass("sticky");
  }
};
$(window).scroll(function () {
  headerscroll();
});
// home banner slider
$('.banner-slider').slick({
    infinite: true,
    slidesToShow: 1
});
// home banner slider
$('.feature-slider').slick({
  infinite: true,
  slidesToShow: 1,
  vertical: true,
  verticalSwiping: true,
  arrows:false,
  touchThreshold:100,
  dots:true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        vertical: false,
        verticalSwiping: false,
      }
    },
  ]
});
// location slider
$('.location-slider').slick({
  infinite: true,
  slidesToShow: 1,
  arrows:true,
  variableWidth: true
});
// product slider
$('.product-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade:true,
  asNavFor: '.product-thumb-slider'
});
$('.product-thumb-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.product-slider',
  dots: false,
  focusOnSelect: true
});
// testimonial slider css
$('.testimonial-slider').slick({
  infinite: true,
  slidesToShow: 1
});

// nav toggle
$(".navbar-toggler").click(function(){
  $(this).toggleClass("open-menu");
  $("header").toggleClass("bg-white");
});
// wow js
new WOW().init();
// show go to top button
/*** Back to top btn Js ***/
if ($('#go-top').length) {
  var scrollTrigger = 150, // px
    backToTop = function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        $('#go-top').addClass('show');
      } else {
        $('#go-top').removeClass('show');
      }
    };
  backToTop();
  $(window).on('scroll', function () {
    backToTop();
  });
}
// home page video
$(document).ready(function () {
  //jQuery(".nk-preloader").fadeOut();
  var video = document.getElementById("flooring-video");
  var playPauseButton = $("#playPauseButton");
  playPauseButton.click(function() {
      if (video.paused) {
          video.play();
        playPauseButton.children().attr('src','dist/client/img/video-pause-button.png');
          playPauseButton.addClass("remove-icon");
          $(".video-sec").addClass("before-unset");
      } else {
          video.pause();
        playPauseButton.children().attr('src','dist/client/img/play-button.svg');
          playPauseButton.removeClass("remove-icon");
          $(".video-sec").removeClass("before-unset");
      }
  });
});
// loader
//$(window).on('load', function () {
//  jQuery(".nk-preloader").fadeOut();
//});
// google translate
function googleTranslateElementInit() {

  new google.translate.TranslateElement({
    pageLanguage: 'en'
  }, 'google_translate_element');

}
